var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-state",style:({paddingTop: (_vm.top || 0) + 'px' })},[_c('img',{class:_vm.type,attrs:{"src":_vm.img_src}}),_c('span',{staticClass:"tx"},[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []

export { render, staticRenderFns }